<!-- 少数默认补料弹框 -->
<template>
  <el-dialog 
    append-to-body
    width="545px" 
    title="少数默认补料" 
    top="200px" 
    class="lack-handle-type-dialog"
    :close-on-click-modal="false" 
    :lock-scroll="false"
    :visible.sync="isShow" 
    @close="close"
  >
    <div v-loading="feeLoading" class="lackHandleTypeDialog__content">
      <div v-if="!isDefaultValueConfig" class="lackHandleTypeDialog__content__alert">
        {{ alertText }}
      </div>
      <el-form 
        class="lackHandleTypeDialog__form" 
        size="small" 
        label-width="130px"
      >
        <BaseFormItem label="少数订单数量：" isShowRequiredIcon>
          <BaseRadioGroup v-model="val.lack_handle_number_type" @change="handleNumberTypeChange">
            <el-radio-button
              v-for="(label, value) in numberTypeOptions"
              :key="value"
              :label="+value"
            >{{ label }}</el-radio-button>
          </BaseRadioGroup>
        </BaseFormItem>
        <BaseFormItem label="少数占比大于：" :isShowRequiredIcon="!disabledNumber">
          <div class="lackHandleTypeDialog__form__input">
            <BaseInput 
              v-model="val.lack_handle_number" 
              width="98px"
              :placeholder="disabledNumber ? '' : '请输入'"
              :disabled="disabledNumber"
              @change="handleNumberChange"
            />
            <span class="lackHandleTypeDialog__form__input__unit">
              {{ options.lack_handle_number_unit[val.lack_handle_number_unit] || '' }}
            </span>
          </div>
          <span v-if="!disabledNumber" slot="other" class="lackHandleTypeDialog__form__inputTips">
            系统会按少数自动补料，否则按自动退款处理
          </span>
        </BaseFormItem>
        <BaseFormItem label="少数发货方式：" isShowRequiredIcon>
          <BaseRadioGroup v-model="val.lack_handle_shipping_type">
            <el-radio-button
              v-for="(label, value) in options.lack_handle_shipping_type"
              :key="value"
              :label="+value"
            >{{ label }}</el-radio-button>
          </BaseRadioGroup>
        </BaseFormItem>
        <BaseFormItem label="收费金额：">
          {{ lackhandlefee }}元
        </BaseFormItem>
      </el-form>
    </div>
    <div slot="footer" class="lackHandleTypeDialog__footer">
      <el-button size="medium" @click="handleCancel">取消</el-button>
      <el-button size="medium" type="primary" @click="handleConfirm">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
const options = {
  lack_handle_number_type: {
    1: '按百分比',
    2: '按订单数',
    // 3: '完全不接受少数'
  },
  lack_handle_number_unit: { 1: '%', 2: 'Pcs', 3: 'Set' },
  lack_handle_shipping_type: {
    1: '和订单一起发货',
    2: '少数单独发货'
  }
}

export const getLackHandleText = (val) => {
  const numberType = options.lack_handle_number_type[val.lack_handle_number_type]
  const numberUnit = val.lack_handle_number_type == 3 ? '' : val.lack_handle_number + options.lack_handle_number_unit[val.lack_handle_number_unit]
  const shippingType = options.lack_handle_shipping_type[val.lack_handle_shipping_type]
  return `
    ${numberType}，
    ${numberUnit ? numberUnit + '，' : ''}
    ${shippingType}
  `
}

export default {
  props: {
    // quote-计价页 return-返单页 defaultValueConfig-默认值配置
    pageSource: {
      type: String,
      default: 'quote'
    },
    // options: {
    //   type: Object,
    //   default: () => ({})
    // }
    // 获取少数处理方式费
    getFee: {
      type: Function,
      default: () => {}
    },
  },
  data() {
    return {
      isShow: false,
      feeLoading: false,
      options,
      pcbParams: {
        bcount: '',
        units: '',
        layoutx: 1,
        layouty: 1,
      },
      val: {
        lack_handle_number_type: 1, // 少数订单数量 1-按百分比 2-按订单数 3-完全不接受少数
        lack_handle_number: 2, // 少数占比大于(按百分比时小数，其余整数)
        lack_handle_number_unit: 1, // 少数补料数量单位： 1-% 2-pcs 3-set
        lack_handle_shipping_type: 1, // 少数发货类型 1-和订单一起发货 2-少数单独发货
      },
      lackhandlefee: '', // 少数处理方式费
    }
  },
  computed: {
    isDefaultValueConfig() { 
      return this.pageSource === 'defaultValueConfig'
    },
    // 少数订单数量选项
    numberTypeOptions() {
      // 默认值配置 不允许选择 按订单数
      if (this.isDefaultValueConfig) {
        return ({
          1: '按百分比',
          // 3: '完全不接受少数'
        })
      }
      return options.lack_handle_number_type
    },
    numberUnit() {
      // 返单页固定为 Pcs
      if (this.pageSource === 'return') {
        return 'Pcs'
      }
      return { 1: 'Pcs', 2: 'Pcs', 3: 'Set' }[this.pcbParams.units]
    },
    // pcs数量
    pcsNum() {
      const { bcount, units, layoutx, layouty } = this.pcbParams
      return units == 2 ? bcount * layoutx * layouty : bcount
    },
    // 展示文案
    alertText() {
      const { numberUnit, pcsNum } = this
      return `尊敬的客户，您当前板子${pcsNum || '--'}${numberUnit}，请确认少数处理方式`
    },
    // 禁用少数占比大于
    disabledNumber() {
      return this.val.lack_handle_number_type == 3
    }
  },
  methods: {
    open({ bcount, units, layoutx = 1, layouty = 1, ...val }) {
      this.pcbParams = Object.assign(this.pcbParams, { bcount, units, layoutx, layouty })
      // 没设置值时，默认：按百分比 2 和订单一起发货
      this.val = Object.assign(this.val, {
        lack_handle_number_type: val.lack_handle_number_type || 1,
        lack_handle_number: val.lack_handle_number || (val.lack_handle_number_type != 3 ? 2 : ''),
        lack_handle_number_unit: val.lack_handle_number_unit ||  1,
        lack_handle_shipping_type: val.lack_handle_shipping_type ||  1
      })
      this.getLackhandlefee()
      this.isShow = true
    },
    close() {
      this.isShow = false
    },
    // 取消
    handleCancel() {
      this.close()
    },
    // 确认
    handleConfirm() {
      const { lack_handle_number_type, lack_handle_number, lack_handle_shipping_type } = this.val
      if (!lack_handle_number_type) {
        return this.$message.warning('请选择少数订单数量！')
      }
      if (lack_handle_number_type != 3 && !lack_handle_number && lack_handle_number !== 0) {
        return this.$message.warning('请录入少数占比大于数！')
      }
      if (lack_handle_number_type != 3 && lack_handle_number <= 0) {
        return this.$message.warning('完全不接受少数，请选择完全不接受少数！')
      }
      if (!lack_handle_shipping_type) {
        return this.$message.warning('请选择少数发货方式！')
      }
      this.$emit('confirm', { ...this.val })
      this.close()
    },
    // 少数订单切换
    handleNumberTypeChange(val) {
      // lack_handle_number_unit: { 1: '%', 2: 'Pcs', 3: 'Set' },
      if (val == 1) {
        // 按百分比
        this.val.lack_handle_number_unit = 1
      } else if (val == 2) {
        // 按订单数
        this.val.lack_handle_number_unit = { 'Pcs': 2, 'Set': 3 }[this.numberUnit]
      } else {
        // 完全不接受少数
        this.val.lack_handle_number_unit = ''
      }
      this.val.lack_handle_number = ''
    },
    // 少数数量改变
    handleNumberChange(val) {
      val = parseFloat(val)
      if (isNaN(val)) {
        val = ''
      } else {
        val = {
          // 按百分比（保留两位小数），且小于100%
          1: Math.min(Math.round(val * 100) / 100, 100),
          // 按订单数（取整），且小于订单数量
          2: Math.min(Math.round(val), this.pcsNum),
          // 完全不接受少数
          3: ''
        }[this.val.lack_handle_number_type]
      }
      
      this.val.lack_handle_number = val
    },
    // 获取少数处理方式费
    async getLackhandlefee() {
      try {
        this.feeLoading = true
        const lackhandlefee = await this.getFee()
        this.lackhandlefee = lackhandlefee
      } finally {
        this.feeLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.lack-handle-type-dialog ::v-deep {
  .el-dialog__body {
    padding: 8px 20px;
  }
}
.lackHandleTypeDialog__content {
  .lackHandleTypeDialog__content__alert {
    padding: 0 11px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    color: $--tips-color;
    border-radius: $--border-radius-base;
    background-color: $--tips-background-color;
  }
  .lackHandleTypeDialog__form {
    margin-top: 20px;
    .lackHandleTypeDialog__form__input {
      position: relative;
      width: 98px;
      & ::v-deep {
        .base-input {
          width: 100%;
          .el-input__inner {
            padding-right: 30px;
          }
        }
      }
      .lackHandleTypeDialog__form__input__unit {
        position: absolute;
        top: 1px;
        right: 0;
        display: block;
        padding: 0 8px;
        height: 30px;
        line-height: 30px;
      }
    }
    .lackHandleTypeDialog__form__inputTips {
      font-size: 12px;
      color: #999;
    }
  }
}
.lackHandleTypeDialog__footer {
  .el-button {
    margin-left: 10px;
    &.el-button--default {
      &:hover {
        color: #059A58;
        border-color: #b4e1cd;
        background-color: #e6f5ee;
      }
    }
    &.el-button--primary {
      border-color: #C00;
      background-color: #C00;
      &:hover {
        border-color: #B80000;
        background-color: #B80000;
      }
    }
  }
}
</style>